/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_EyebrowInputs */

const tr_landing_hero_eyebrow = /** @type {(inputs: Landing_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm pazaryerleri. Tek kokpit.`)
};

const en_landing_hero_eyebrow = /** @type {(inputs: Landing_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All marketplaces. One cockpit.`)
};

const de_landing_hero_eyebrow = /** @type {(inputs: Landing_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Marktplätze. Ein Cockpit.`)
};

const ru_landing_hero_eyebrow = /** @type {(inputs: Landing_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все маркетплейсы. Один центр управления.`)
};

/**
* | output |
* | --- |
* | "All marketplaces. One cockpit." |
*
* @param {Landing_Hero_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_hero_eyebrow = /** @type {((inputs?: Landing_Hero_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_eyebrow(inputs)
	if (locale === "de") return de_landing_hero_eyebrow(inputs)
	if (locale === "ru") return ru_landing_hero_eyebrow(inputs)
	return tr_landing_hero_eyebrow(inputs)
});